import { ObjectSelector, SelectedItems } from '../selector/selector';
import React from 'react';
import useAppContext from '../../../../context/useAppContext';
import Inventory from '../../../../models/inventory';
import { useTranslation } from 'react-i18next';

/**
 * Inventory Selector.
 * Used to select a inventory or many inventories
 * @param inventories - list inventories objects (not ids)
 * @param eventsSelectedObjects - Current event object
 * @param onchange - function to perform on actions
 * @param many - boolean to know if we have to select many events or not
 */
export function InventorySelector({ inventories, eventsSelectedObjects, onChange, many = false }) {
    const { t } = useTranslation();
    const [{ organization }] = useAppContext();

    if (!eventsSelectedObjects?.chart) {
        return null;
    }
    return (
        <ObjectSelector
            objects={inventories}
            Model={Inventory}
            requestParams={{ organizationId: organization.pk, chartId: eventsSelectedObjects?.chart, launch: Boolean(eventsSelectedObjects?.chart) }}
            queryParams={{
                query: { event: eventsSelectedObjects.pk, active: true }
            }}
            onChange={onChange}
            many={many}
            requestDeps={[eventsSelectedObjects]}
            label={t('ticket.widget.singleEvent.titleInventory')}
            placeholder={t('ticket.widget.singleEvent.placeholderInventory')}
        >
            {many === true && (
                <SelectedItems
                    objects={inventories}
                    onRemoveObject={obj => {
                        let tmp_tab = [...inventories];
                        let index = tmp_tab.findIndex(object => object.pk === obj.pk);
                        tmp_tab.splice(index, 1);
                        return onChange(tmp_tab);
                    }}
                    name={t('ticket.widget.singleEvent.selectedInventories')}
                />
            )}
        </ObjectSelector>
    );
}
